<template>
  <div class="study_profile_modal__wrapper">
    <div class="study_profile_modal__container">
      <div class="modal__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">Manage Cycle Schedule</h4>
        <div class="col-lg-2">
           <span class="tooltip-wrapper pointer" style="float:right">
         
           <i class="fa fa-times cursor-pointer" @click.prevent="closeModal"></i>
        
          <span class="custom-tooltip closetooltipposition">Close</span>
  </span>
        </div>
      </div>
      <div class="ibox-content p-0">
        <div class="modal-body pb-0">
          <div class="form-group row">

            <div class="col-lg-4 my-0">
            <label class="col-form-label">Cycle Name</label>
            <input type="text" class="form-control" v-model="cycleData.cycleName" readonly />
            </div>
            <div class="col-lg-4 my-0">
            <label class="col-form-label">Cycle Duration (Days)</label>
            <input type="text" class="form-control" v-model="cycleData.cycleDuration" readonly />
            </div>
            <div class="col-lg-4 my-0">
                <label class="col-form-label">
                    occurence
                    
                </label>
                <input
                    class="form-control"
                    type="text"
                    v-model="cycleoccurence"
                    readonly
                />
            </div>

            <div class="col-lg-6 my-0">
                <label class="col-form-label">
                    Start Date
                    <sup><i class="fa fa-asterisk required"></i></sup>
                </label>
                <input
                    class="form-control"
                    type="date"
                    v-model="cycleForm.startDate"
                    @change="onStartDateChange"
                />
                <span class="errormsg" v-if="cycleErrors.startDate">
                    Select a start date.
                </span>
            </div>

            <div class="col-lg-6 my-0">
                <label class="col-form-label">
                    End Date
                    
                </label>
                <input
                    class="form-control"
                    type="date"
                    v-model="cycleForm.endDate"
                    :min="cycleForm.startDate || today"
                />
            </div>
            

            <div class="col-lg-12 mt-4 d-flex justify-content-lg-end">
                <button
                    class="save_btn py-1 px-4"
                    type="button"
                    @click.prevent="createSchedule"
                    :disabled="isCreating"
                    >
                    <span v-if="isCreating"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-else>Update</span>
                </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./ManageCyclePopup.js"></script>
<style scoped>
@import "../../assets/css/style.css";

.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  width: min(50%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.modal__title {
  background-color: #618bd7;
  color: #fff;
}

.save_btn {
  text-align: center;
  background-color: #145faf !important;
  border-color: #145faf !important;
  color: white !important;
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out !important;
}

.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
}

.save_btn:not(:disabled):hover,
.save_btn:focus:focus-visible {
  background-color: #145faf !important;
  border-color: #145faf !important;
}

.save_btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
